import CheckValueField from "@/src/components/CheckValueField";
import { ArrayField, ChipField, Datagrid, DateField, List, ReferenceArrayField, SingleFieldList, TextField } from "react-admin";

export const TenantList = () => (
    <List>
        <Datagrid
            bulkActionButtons={false}
        >
            <TextField source="id" />
            <TextField source="name" />
            <ReferenceArrayField source="users" reference="user" >
                <SingleFieldList>
                    <ChipField source="email" />
                </SingleFieldList>
            </ReferenceArrayField>
            {/* <TextField source="patterns" /> */}
            <CheckValueField source="restrict" checkedValue="tenant" />
            <ArrayField source="permissions">
                <SingleFieldList>
                    <ChipField source="resource" />
                </SingleFieldList>
            </ArrayField>
            <DateField source="createdAt" />
            <DateField source="updatedAt" />

        </Datagrid>
    </List>
);